import { TextDisplay, Heading1, Flex, Link } from '@libs/ahoy/src';

import logo from './images/teamleader_logo_default.svg';
import * as styles from './index.css';
import { useFlagsWithFallback } from './useFlagsWithFallback';

export default function App() {
  const flags = useFlagsWithFallback();

  const timeAndDateString: string = flags.downtimeTimeAndDateValue;
  let timeAndDateFormatted = '';

  if (Date.parse(timeAndDateString)) {
    const timeAndDate = new Date(timeAndDateString);

    if (!isNaN(timeAndDate.getTime())) {
      timeAndDateFormatted = timeAndDate.toLocaleString(navigator.language, {
        dateStyle: 'medium',
        timeStyle: 'long',
      });
    }
  }

  return (
    <Flex className={styles['container']} direction="column">
      <Flex justifyContent="center" paddingVertical={6} element="header">
        <img src={logo} alt="Teamleader logo" title="Teamleader logo" className={styles['logo']} />
      </Flex>
      <Flex
        direction="column"
        justifyContent="center"
        alignItems="center"
        flex={1}
        element="main"
        paddingHorizontal={4}
      >
        <Heading1 marginBottom={6}>Whoops, Teamleader Focus is down for maintenance</Heading1>
        <TextDisplay marginBottom={3}>
          We apologize for the inconvenience as we are currently making improvements.
        </TextDisplay>
        <TextDisplay marginBottom={3}>
          {timeAndDateFormatted ? (
            <>
              We&apos;ll be back up and running at around <strong>{timeAndDateFormatted}</strong>.
            </>
          ) : (
            <>We&apos;ll be back up and running soon.</>
          )}
        </TextDisplay>
        <TextDisplay>
          Subscribe to our{' '}
          <Link inherit={false} href="https://status.teamleader.eu">
            statuspage
          </Link>
          , to stay updated!
        </TextDisplay>
      </Flex>
      <Flex className={styles['main-image-container']} marginTop={6} />
    </Flex>
  );
}
